import {
  Box,
  Chip,
  Container,
  Grid,
  Paper,
  Typography,
  Tooltip,
} from "@mui/material";
import {
  AutoAwesomeRounded,
  SmartToyRounded,
  BoltRounded,
} from "@mui/icons-material";
import AISuggestionItem from "./AiSuggestion";
import MissedOpportunities, { OpportunityItem } from "./MissedOpp";
import { DonutLargeRounded } from "@mui/icons-material";
import { AttachMoneyRounded } from "@mui/icons-material";
import { ChatBubbleOutlineRounded } from "@mui/icons-material";
import FeedbackItem from "./FeedbackItem";
import InfoIcon from "@mui/icons-material/Info";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";
import { purple } from "@mui/material/colors";



const ui = {
  pageBg: "#fafaff",
  cardBg:
    "linear-gradient(180deg, rgba(252,252,255,0.9) 0%, rgba(247,247,253,0.85) 100%)",
  border: "#e7e5ef",
  // heading: "#111827",
  heading:colorTheme('palette', 'night').value,
  sub: "#6b7280",
  // purple: "#7c3aed",
  purple:colorTheme('palette', 'primary').value
};

export function CoachingTip({ description }) {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: "#F8F8F9",
        // border: `1px solid  #D2D2D2`,
        borderRadius: 5,
        p: { xs: 1.5, sm: "1rem" },
        mb: 2,
      }}
    >
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: "0.9rem",
            color: "hsl(var(--card-foreground))",
          }}
        >
          {title}
        </Typography>
        <PriorityChip priority={priority} />
        <Chip
          size="small"
          label={priorityLable}
          sx={{
            height: 24,
            bgcolor: priorityBg,
            color: priorityColor,
            fontWeight: 600,
            fontSize: "0.75rem",
            "& .MuiChip-label": { px: 1 },
          }}
        />
      </Box> */}
      <Typography
        variant="body1"
        sx={{
          // color: "hsl(240 3.8% 46.1%)",
          fontWeight: 500,
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
        }}
      >
        {description}
      </Typography>
    </Paper>
  );
}

function Section({ title, icon, children, info }) {
  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        borderRadius: 5,
        p: { xs: 1.5, sm: 2 },
        border: `1px solid #F0F0F2`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          mb: { xs: 1.25, sm: 1.75 },
        }}
      >
        {icon}
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, fontSize: "1rem", lineHeight: "1.75rem" }}
        >
          {title}
        </Typography>
        <Tooltip title={info}>
          <InfoIcon sx={{ fontSize: 18, color: "grey", cursor: "pointer" }} />
        </Tooltip>
      </Box>
      {children}
    </Paper>
  );
}

export default function AiInsight({ agentKpisData, agentProfileData }) {
  const mergedCustomerFeedback = [
    ...agentKpisData?.customerFeedbackTrends.topStrengths,
    ...agentKpisData?.customerFeedbackTrends.topImprovements,
  ];

  const suggestions = [
    {
      title: "Improve Product Knowledge",
      description:
        "Consider scheduling training sessions on new product features to enhance customer support quality.",
      tag: "Training",
      priority: "high",
    },
    {
      title: "Optimize Call Flow",
      description:
        "Use call scripts for common scenarios to reduce handle time and improve consistency.",
      tag: "Efficiency",
      priority: "medium",
    },
    {
      title: "Active Listening Enhancement",
      description:
        "Practice paraphrasing techniques to better understand customer needs.",
      tag: "Communication",
      priority: "low",
    },
  ];
  const items = [
    {
      sentiment: "positive",
      text: agentKpisData?.customerFeedbackTrends?.topImprovements[0]?.text,
      // agentProfileData?.customerFeedbackTrends?.topImprovements?.length > 0
      //   ? agentProfileData?.customerFeedbackTrends?.topImprovements[0]?.text
      //   : "",
      category: "Problem Resolution",
      timeAgo: "2 hours ago",
    },
    {
      sentiment: "positive",
      text: "Great service, very professional and patient.",
      category: "Communication",
      timeAgo: "4 hours ago",
    },
    {
      sentiment: "neutral",
      text: "Could have been faster, but the solution worked.",
      category: "Efficiency",
      timeAgo: "6 hours ago",
    },
    {
      sentiment: "negative",
      text: "Agent seemed to lack knowledge about the new product features.",
      category: "Product Knowledge",
      timeAgo: "1 day ago",
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      {/* Page heading */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography
          variant={"h2"}
          sx={{
            fontSize: "1.125rem",
            fontWeight: 700,
            background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
            lineHeight: "1.75rem",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          AI Coach Insights
        </Typography>

        <Chip
          size="small"
          label="Smart Tips"
          icon={<SmartToyRounded sx={
            { color: `${colorTheme('palette', 'primary').value} !important` }
          } />}
          sx={{
            height: 22,
            fontWeight: 500,
            fontSize: "0.75rem",
            bgcolor: "#f1efff",
            // color: "#6d28d9",
            color:colorTheme('palette', 'primary').value
          }}
        />
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          {/* Section */}
          {agentProfileData?.topSuggestedActionSteps?.length > 0  && (
            <Section
              title="AI‑Generated Suggestions"
              info="AI reviews every call and provide suggestions."
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  // color="#6366F1"
                  color={colorTheme('palette', 'primary').value}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-brain w-5 h-5 text-primary"
                  data-lov-id="src/components/dashboard/AIInsights.tsx:58:10"
                  data-lov-name="Brain"
                  data-component-path="src/components/dashboard/AIInsights.tsx"
                  data-component-line="58"
                  data-component-file="AIInsights.tsx"
                  data-component-name="Brain"
                  data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
                >
                  <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
                  <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path>
                  <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path>
                  <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path>
                  <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path>
                  <path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path>
                  <path d="M19.938 10.5a4 4 0 0 1 .585.396"></path>
                  <path d="M6 18a4 4 0 0 1-1.967-.516"></path>
                  <path d="M19.967 17.484A4 4 0 0 1 18 18"></path>
                </svg>
              }
            >
              <Box sx={{ display: "grid", gap: { xs: 1, sm: 1.25 } }}>
                {agentProfileData?.topSuggestedActionSteps?.length > 0 ? (
                  agentProfileData?.topSuggestedActionSteps?.map(
                    (suggestion) => {
                      return (
                        <AISuggestionItem description={suggestion?.value} />
                      );
                    }
                  )
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    No Data Available
                  </Box>
                )}
              </Box>
            </Section>
          )}
        </Grid>

        <Grid item xs={12} md={6}>
          {/* <MissedOpportunities /> */}

          {agentProfileData?.topMissedOpportunities?.length > 0 && (
            <Section
              title="Missed Opportunities"
              info="AI flags moments where an upsell, empathy or probe was possible"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  // color="#6366F1"
                  color={colorTheme('palette', 'primary').value}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-target w-5 h-5 text-primary"
                  data-lov-id="src/components/dashboard/AIInsights.tsx:91:10"
                  data-lov-name="Target"
                  data-component-path="src/components/dashboard/AIInsights.tsx"
                  data-component-line="91"
                  data-component-file="AIInsights.tsx"
                  data-component-name="Target"
                  data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="6"></circle>
                  <circle cx="12" cy="12" r="2"></circle>
                </svg>
              }
            >
              <Box sx={{ display: "grid", gap: { xs: 1, sm: 1.25 } }}>
                {agentProfileData?.topMissedOpportunities?.length > 0 ? (
                  agentProfileData?.topMissedOpportunities?.map((missed) => {
                    return (
                      <OpportunityItem
                        title={missed?.value}
                        revenueNote="Could have generated $200 additional revenue"
                        suggestion={missed?.value}
                        callId="CALL-2024-001"
                      />
                    );
                  })
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    No Data Available
                  </Box>
                )}
              </Box>
            </Section>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          {/* customer feedback */}
          { mergedCustomerFeedback && (
            <Section
              title="Customer Feedback Analysis"
              info="AI summarises post-call CSAT & sentiment into scores"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  // color="#6366F1"
                  color={colorTheme('palette', 'primary').value}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-message-circle w-5 h-5 text-primary"
                  data-lov-id="src/components/dashboard/AIInsights.tsx:121:10"
                  data-lov-name="MessageCircle"
                  data-component-path="src/components/dashboard/AIInsights.tsx"
                  data-component-line="121"
                  data-component-file="AIInsights.tsx"
                  data-component-name="MessageCircle"
                  data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
                >
                  <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
                </svg>
              }
            >
              <Box sx={{ display: "grid", gap: { xs: 1, sm: 1.25 } }}>
                {mergedCustomerFeedback?.map((f, i) => (
                  <FeedbackItem
                    key={i}
                    //   sentiment={f.sentiment}
                    text={f.text}
                    //   category={f.category}
                    //   timeAgo={f.timeAgo}
                  />
                ))}
              </Box>
            </Section>)
          }
        </Grid>

        <Grid item xs={12} md={6}>
          {agentProfileData?.topSuggestedActionSteps &&  (<Section
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                // color="#6366F1"
                color={colorTheme('palette', 'primary').value}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-lightbulb w-5 h-5 text-primary"
                data-lov-id="src/components/dashboard/PerformanceComparison.tsx:123:10"
                data-lov-name="Lightbulb"
                data-component-path="src/components/dashboard/PerformanceComparison.tsx"
                data-component-line="123"
                data-component-file="PerformanceComparison.tsx"
                data-component-name="Lightbulb"
                data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
              >
                <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path>
                <path d="M9 18h6"></path>
                <path d="M10 22h4"></path>
              </svg>
            }
            title="AI-Generated Coaching Tips"
            info="AI creates personalised next-step drills for the agent to practice"
            sx={{ mt: 2 }}
          >
            {agentProfileData?.topSuggestedActionSteps?.length > 0
              ? agentProfileData?.topSuggestedActionSteps?.map((steps) => {
                  return (
                    <CoachingTip
                      title="Active Listening"
                      description={steps?.value}
                      priority="Medium Priority"
                      // priorityBg="hsl(47.9 95.8% 53.1%)"
                      priorityBg={colorTheme('palette', 'neutral').value}
                      priorityLable="Medium Priority"
                      priorityColor="hsl(26 83.3% 14.1%)"
                    />
                  );
                })
              : ""}
          </Section>)}
       

        </Grid>
      </Grid>
    </Box>
  );

}
